
import {defineComponent} from "vue";

export default defineComponent({
  name: "GradientButton",
  props: {
    title: {
      type: String,
      required: true
    }
  }
});
